export enum SignUpStep {
    RegistrationInfo,
    Confirmation,
}

export enum PasswordRecoveryStep {
    VerificationMethod,
    Confirmation,
    NewPassword,
}
